import * as React from "react";

import { Grid, Button, Table, Loader } from "semantic-ui-react";

import { useSelector } from "react-redux";
import { Authorize } from "reauthorize";

import { GenericCaseTypeApi } from "../GenericCaseTypeApi";
import { ApplicationState } from "../../applicationState";

import { GenericCaseType } from "../models";
import { ADMIN_ROLES } from "../../auth";

import { CreateGenericCaseType } from "./CreateGenericCaseType";

import { Link, Fragment } from "redux-little-router";

export const AllGenericCaseTypes: React.FunctionComponent = () => {
    const [loading, setLoading] = React.useState(false);
    const [genericCaseTypes, setGenericCaseTypes] = React.useState<GenericCaseType[]>([]);

    React.useEffect(() => {
        (async () => {
            setLoading(true);
            setGenericCaseTypes(await GenericCaseTypeApi.getAll());
            setLoading(false);
        })();
    }, []);

    const path = useSelector((state: ApplicationState) => state.router.pathname);

    const onGenericCaseTypeCreated = React.useCallback(
        (genericCaseType: GenericCaseType) => setGenericCaseTypes([...genericCaseTypes, genericCaseType]),
        [genericCaseTypes]
    );

    return (
        <>
            <Grid container className="nomargintop">
                <Grid.Row>
                    <Grid.Column width="14">
                        <h1>Generic Case Types</h1>
                    </Grid.Column>
                    <Grid.Column width={2} textAlign="right">
                        <Authorize authorize={[ADMIN_ROLES.SYSTEM_ADMIN.name]}>
                            <Button icon="add" content="Create" as={Link} href={`${path}/create`} />
                        </Authorize>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    {loading ? <Loader active /> :
                        <Grid.Column width={16}>
                            <Table>
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell width={10}>Name</Table.HeaderCell>
                                        <Table.HeaderCell width={2} textAlign="center">Active</Table.HeaderCell>
                                        <Table.HeaderCell width={2} textAlign="center">Available to Customer</Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body>
                                    {genericCaseTypes.sort((a, b) => a.name > b.name ? 1 : -1).map(genericCaseType => (
                                        <Table.Row key={genericCaseType.id}>
                                            <Table.Cell width={10}>
                                                <Link href={`${path}/${genericCaseType.id}`}>
                                                    {genericCaseType.name}
                                                </Link>
                                            </Table.Cell>
                                            <Table.Cell width={2} textAlign="center">
                                                <Link href={`${path}/${genericCaseType.id}`}>
                                                    {genericCaseType.active ? "Yes" : "No"}
                                                </Link>
                                            </Table.Cell>
                                            <Table.Cell width={2} textAlign="center">
                                                <Link href={`${path}/${genericCaseType.id}`}>
                                                    {genericCaseType.availableToCustomer ? "Yes" : "No"}
                                                </Link>
                                            </Table.Cell>
                                        </Table.Row>
                                    ))}
                                </Table.Body>
                            </Table>
                        </Grid.Column>}
                </Grid.Row>
            </Grid>
            <Fragment forRoute="/create">
                <CreateGenericCaseType onGenericCaseTypeCreated={onGenericCaseTypeCreated} />
            </Fragment>
        </>
    );
};
